<div class="bg_image">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center text-style">
                <marquee direction="right" behavior="alternate">
                    <label>
                        <b>
                            For query or support 
                            <a href="tel:+8809612717171">
                                <i class="fa fa-phone-square fa-lg ml-2 mr-1" aria-hidden="true"></i>
                                <span style="color:green;">09612
                                </span><span style="color: red;">71 71 71</span>
                            </a>
                        </b>
                    </label>
                </marquee>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="embed-responsive embed-responsive-16by9 customHeight">
                    <iframe class="embed-responsive-item" alt="intro_video" allowfullscreen
                        src="assets\eTaxServiceContent\eReturn_intro.mp4"></iframe>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="customHeight">
                    <div class="row">
                        <div class="col-6">
                            <img src="assets\eTaxServiceContent\service_center_2.jpeg" class="img-fluid">
                        </div>
                        <div class="col-6">
                            <img src="assets\eTaxServiceContent\service_center_3.jpeg" class="img-fluid">
                        </div>
                        <div class="col-12">
                            <img src="assets\eTaxServiceContent\service_center_1.jpeg" class="img-fluid service_center_image_1">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Previous style start-->

        <!-- <div class="row p-3">
            <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" alt="intro_video" allowfullscreen
                    src="assets\eTaxServiceContent\eReturn_intro.mp4"></iframe>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <img src="assets\eTaxServiceContent\service_center_2.jpeg" class="img-fluid">
            </div>
            <div class="col-4">
                <img src="assets\eTaxServiceContent\service_center_3.jpeg" class="img-fluid">
            </div>
            <div class="col-4">
                <img src="assets\eTaxServiceContent\service_center_1.jpeg" class="img-fluid">
            </div>
        </div> -->

        <!-- Previous style end-->

        <div class="row mt-3">
            <div class="col-12">
                <button type="button" class="btn btn-sm backBtn mb-3" (click)="onBacktoMainPage()">
                    <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left"
                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                    </svg>&nbsp;
                    Back to main</button>
            </div>
        </div>
    </div>
</div>